// Matches the various messages browsers/Angular emit when a lazy-loaded chunk
// can no longer be fetched (typically because a new release replaced the
// content-hashed filenames the currently-open tab still references).
// Kept free of Angular/Sentry imports so Node unit tests can load it directly.
const CHUNK_FAILED_PATTERNS = [
    // Chrome
    'Failed to fetch dynamically imported module',
    // Firefox
    'error loading dynamically imported module',
    // Safari (iOS / generic)
    'Importing a module script failed',
    // Safari (desktop): the SPA fallback answers a stale chunk request with
    // index.html and import() rejects with "'text/html' is not a valid
    // JavaScript MIME type." (Sentry issue 7569772724)
    'is not a valid JavaScript MIME type',
    // webpack-style builds
    'Loading chunk [\\w-]+ failed',
    'ChunkLoadError',
];
const CHUNK_FAILED_MESSAGE = new RegExp(CHUNK_FAILED_PATTERNS.join('|'), 'i');

function isChunkLoadErrorMessage(error: unknown): boolean {
    const candidate = error as { message?: string; toString?: () => string } | null;
    const message = candidate?.message ?? candidate?.toString?.() ?? '';
    return CHUNK_FAILED_MESSAGE.test(message);
}

export { isChunkLoadErrorMessage };
